
import moment from 'moment/moment.js'

// const host = "http://cdl-booking-api.pxppldev.com/";
// const host = "http://178.128.126.187/cdl_api/";
const host = "https://booking-api.cdlhomes.com.sg/";
const access_endpoint_link = host + "Access_Api/";
const endpoint_link = host + "api/";

const format_request = (postparam) => {
    postparam['user_token'] = window.localStorage.getItem("user_token");
    postparam['user_id'] = window.localStorage.getItem("user_id");
    postparam['role'] = window.localStorage.getItem("role");
    let body = '';
    for (let k in postparam) {
        body += encodeURI(k) + "=" + encodeURI(postparam[k]) + "&";
    }
    var postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body
    };
    return postOptions;
}
export const login = async (postparam) => {
    let body = '';
    for (let k in postparam) {
        body += encodeURI(k) + "=" + encodeURI(postparam[k]) + "&";
    }
    var postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body
    };
    var reponse = await fetch(access_endpoint_link + "login", postOptions);
    var json = await reponse.json();
    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const get_property_from_timetable = async (timetable_id, date = null) => {
    const postparam = {
        timetable_id: timetable_id
    };
    if (date) {
        postparam['date'] = date;
    }
    var response = await fetch(endpoint_link + 'get_property_from_timetable', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const get_admins = async () => {
    var reponse = await fetch(endpoint_link + "get_admins", format_request({}));
    var json = await reponse.json();
    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const delete_showroom_unit = async (showflat_unit_id) => {
    var response = await fetch(endpoint_link + 'delete_showroom_unit', format_request({
        showroom_unit_id: showflat_unit_id
    }));
    var json = await response.json();
    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const add_showroom_unit = async (data) => {
    var response = await fetch(endpoint_link + 'add_showroom_unit', format_request(data));
    var json = await response.json();
    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};
export const delete_agencies_property = async (agency_id, property_id) => {
    const postparam = {
        agency_id: agency_id,
        property_id: property_id
    };
    var response = await fetch(endpoint_link + 'delete_agencies_property', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const delete_operator_property = async (operator_id, property_id) => {
    const postparam = {
        operator_id: operator_id,
        property_id: property_id
    };
    var response = await fetch(endpoint_link + 'delete_operator_property', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const edit_showroom = async (data) => {
    var response = await fetch(endpoint_link + 'edit_showroom', format_request(data));
    var json = await response.json();
    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const get_showrooms = async () => {
    const postparam = {
        role: window.localStorage.getItem("role"),
        user_token: window.localStorage.getItem("user_token")
    };
    var response = await fetch(endpoint_link + 'get_properties', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const reset_password = async (data) => {
    const postparam = data;
    let body = '';
    for (let k in postparam) {
        body += encodeURI(k) + "=" + encodeURI(postparam[k]) + "&";
    }
    var postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body
    };
    var postOptions;
    var response = await fetch(access_endpoint_link + 'reset_password', postOptions);
    var json = await response.json();
    if (json.status) {
        return true;
    } else {

        return false;
    }
}

export const forgot_password = async (email) => {
    const postparam = {
        email: email
    };
    let body = '';
    for (let k in postparam) {
        body += encodeURI(k) + "=" + encodeURI(postparam[k]) + "&";
    }
    var postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body
    };
    var postOptions;

    var response = await fetch(access_endpoint_link + 'forgot_password', format_request({
        email: email
    }));
    var json = await response.json();
    if (json) {
        console.log(json);
    }

}

export const check_validity = async () => {
    const postparam = {
        user_id: window.localStorage.getItem("user_id"),
        role: window.localStorage.getItem("role"),
        user_token: window.localStorage.getItem("user_token")
    }
    var response = await fetch(endpoint_link + 'validate_user', format_request(postparam));
    var json = await response.json();
    if (json.status) {

        return true;
    } else {
        if (window.location.pathname != "/" && window.location.pathname != "/login") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const get_showroom_details = async (property_id) => {
    const postparam = {
        property_id: property_id
    };
    console.log(format_request(postparam));
    var response = await fetch(endpoint_link + 'get_property_details', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const get_showroom_timetable = async (date, property_id) => {
    const postparam = {
        property_id: property_id,
        date: date
    };
    console.log(format_request(postparam));
    var response = await fetch(endpoint_link + 'get_showroom_timetable', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const get_all_showroom_timetable = async (property_id) => {
    const postparam = {
        property_id: property_id
    };
    console.log(format_request(postparam));
    var response = await fetch(endpoint_link + 'get_property_timetable', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const get_showroom_agencies = async (showroom_id) => {
    const postparam = {
        property_id: showroom_id
    };
    console.log(format_request(postparam));
    var response = await fetch(endpoint_link + 'get_property_agency', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const get_agencies = async () => {
    const postparam = {
    };
    console.log(format_request(postparam));
    var response = await fetch(endpoint_link + 'get_agencies', format_request(postparam));
    var json = await response.json();
    if (json.status) {
        return json.data;
    } else {
        // if (json.message == "AUTH FAIL") {
        //     window.localStorage.clear();
        //     console.log("authentication broken");
        //     window.location.href = "/";
        // }
        return false;
    }
};

export const edit_showroom_timetable = async (data) => {
    var response = await fetch(endpoint_link + 'edit_showroom_timetable', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};
export const add_showroom_timetable = async (data) => {
    var response = await fetch(endpoint_link + 'add_showroom_timetable', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const add_showroom_special_timetable_demo = async (data) => {
    var response = await fetch(endpoint_link + 'add_showroom_special_timetable_demo', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const add_showroom_timetable_demo = async (data) => {
    var response = await fetch(endpoint_link + 'add_showroom_timetable_demo', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const reorder_units = async (data) => {
    var response = await fetch(endpoint_link + 'reorder_units', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const get_agency_showroom = async () => {
    let data = {
        user_token: window.localStorage.getItem("user_token")
    }
    var response = await fetch(endpoint_link + 'get_agency_property', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};
export const get_showroom_by_agency = async (showroom_id, date) => {
    let data = {
        property_id: showroom_id,
        user_token: window.localStorage.getItem("user_token"),
        role: window.localStorage.getItem("role"),
        date: moment(date).format("YYYY-MM-DD")
    };
    var response = await fetch(endpoint_link + 'get_showroom_timetable', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};


export const edit_admin = async (data) => {
    var response = await fetch(endpoint_link + 'edit_admin', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const get_appointment_types = async () => {

    var response = await fetch(endpoint_link + 'get_appointment_types', format_request({}));
    var json = await response.json();

    return json.data;
}
export const create_booking = async (data) => {
    data['user_token'] = window.localStorage.getItem("user_token");
    data['role'] = window.localStorage.getItem("role");
    var response = await fetch(endpoint_link + 'create_agency_booking', format_request(data));
    var json = await response.json();

    return json;
}

export const delete_admin = async (admin_id) => {
    var data = { admin_id: admin_id };
    var response = await fetch(endpoint_link + 'delete_admin', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const delete_agent = async (agent_id) => {
    var data = { agent_id: agent_id };
    var response = await fetch(endpoint_link + 'delete_agent', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const delete_agency = async (agency_id) => {
    var data = { agency_id: agency_id };
    var response = await fetch(endpoint_link + 'delete_agency', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const delete_operator = async (showroom_operator_id) => {
    var data = { showroom_operator_id: showroom_operator_id };
    var response = await fetch(endpoint_link + 'delete_operator', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const get_agent = async (agency_id, role) => {
    var data = { agency_id: agency_id, role: role };
    var response = await fetch(endpoint_link + 'get_agents', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const edit_special_dates_max_appointments = async (data) => {
    var response = await fetch(endpoint_link + 'edit_special_dates_max_appointments', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const delete_special_dates_max_appointment = async (data) => {
    var response = await fetch(endpoint_link + 'delete_special_dates_max_appointment', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}


export const edit_booking = async (data) => {

    var response = await fetch(endpoint_link + 'edit_booking', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const add_special_dates_max_appointments = async (data) => {
    var response = await fetch(endpoint_link + 'add_special_dates_max_appointments', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};
export const get_special_dates_max_appointment = async (data) => {
    var response = await fetch(endpoint_link + 'get_special_dates_max_appointments', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};
export const delete_booking = async (appointment_id) => {
    let data = {
        appointment_id: appointment_id
    }
    var response = await fetch(endpoint_link + 'delete_booking', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};
export const get_booking_info = async (appointment_id) => {
    var data = {
        appointment_id: appointment_id
    };

    var response = await fetch(endpoint_link + 'get_booking_info', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const add_showroom_agency = async (showroom_id, agency_id) => {
    var data = {
        showroom_id: showroom_id,
        agency_id: agency_id
    };

    var response = await fetch(endpoint_link + 'add_property_agency', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const edit_agency = async (data) => {
    var response = await fetch(endpoint_link + 'edit_agency', format_request(data));
    var json = await response.json();

    return json;
}
export const edit_agent = async (data) => {
    var response = await fetch(endpoint_link + 'edit_agent', format_request(data));
    var json = await response.json();

    return json;
}

export const copy_special_date = async (data) => {

    var response = await fetch(endpoint_link + 'copy_special_date', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const get_timetable_detail = async (data) => {
    var response = await fetch(endpoint_link + 'get_timetable_detail', format_request(data));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const get_all_operators = async () => {
    var response = await fetch(endpoint_link + "get_operators", format_request({}));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};
export const edit_showroom_operator = async (data) => {
    var response = await fetch(endpoint_link + "edit_showroom_operator", format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const get_showroom_operator_details = async (showroom_operator_id) => {
    var response = await fetch(endpoint_link + "get_showroom_operator_details", format_request({ showroom_operator_id: showroom_operator_id }));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const add_showroom_operator_showroom = async (showroom_id, showroom_operator_id) => {
    var response = await fetch(endpoint_link + 'add_showroom_operator_showroom', format_request({
        showroom_id: showroom_id,
        showroom_operator_id: showroom_operator_id
    }));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}
export const add_showroom_operator = async (data) => {
    var response = await fetch(endpoint_link + 'add_showroom_operator', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}

export const get_showroom_view = async (token) => {
    var response = await fetch(endpoint_link + 'get_showroom_view', format_request({
        token: token
    }));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const delete_showroom_timetable = async (timeslot_id) => {
    var response = await fetch(endpoint_link + 'delete_showroom_timetable', format_request({
        timeslot_id: timeslot_id
    }));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        alert(json.message);
        return false;
    }

};

export const update_appointment_by_admin = async (appointment_id, data) => {
    var response = await fetch(endpoint_link + 'update_appointment_by_admin', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {

        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        } else {
            alert(json.message);
        }
        return false;
    }
};
export const set_appointment_completed = async (appointment_id, data = {}) => {
    var response = await fetch(endpoint_link + 'set_appointment_completed', format_request({
        appointment_id: appointment_id,
        pax: data.pax,
        agent_pax: data.agent_pax
    }));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {

        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        } else {
            alert(json.message);
        }
        return false;
    }
}

export const reallocate_timeslots = async (data) => {
    var response = await fetch(endpoint_link + 'reallocate_timeslots', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const set_appointment_noshow = async (appointment_id) => {
    var response = await fetch(endpoint_link + 'set_appointment_noshow', format_request({
        appointment_id: appointment_id
    }));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}


export const get_appointments = async (property_id, date) => {
    var response = await fetch(endpoint_link + 'get_appointments', format_request({
        property_id: property_id,
        date: date
    }));
    var json = await response.json();

    if (json.status) {
        return json.data;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
};

export const edit_admin_property = async (data) => {
    var response = await fetch(endpoint_link + 'edit_admin_property', format_request(data));
    var json = await response.json();

    if (json.status) {
        return true;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return false;
    }
}


export const add_admin = async (data) => {
    var response = await fetch(endpoint_link + 'add_admin', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}

export const add_agency = async (data) => {
    var response = await fetch(endpoint_link + 'add_agency', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}

export const add_property = async (data) => {
    var response = await fetch(endpoint_link + 'add_property', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}

export const get_agency_details = async (data) => {
    var response = await fetch(endpoint_link + 'get_agency_details', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}

export const get_agent_details = async (data) => {
    var response = await fetch(endpoint_link + 'get_agent_details', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}

export const get_admin_details = async (data) => {
    var response = await fetch(endpoint_link + 'get_admin_details', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}

export const get_appointment_details = async (data) => {
    var response = await fetch(endpoint_link + 'get_appointment_details', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}

export const get_overview_report = async (option) => {
    var response = await fetch(endpoint_link + 'report_overview', format_request(option));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const get_properties_guest_breakdown = async (data) => {
    var response = await fetch(endpoint_link + 'get_properties_guest_breakdown', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const get_agency_guest_breakdown = async (data) => {
    var response = await fetch(endpoint_link + 'get_agency_guest_breakdown', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const get_overview_agency_report = async (option) => {
    var response = await fetch(endpoint_link + 'report_overview_agency', format_request(option));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const get_property_report = async (option) => {
    var response = await fetch(endpoint_link + 'get_property_report', format_request(option));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const get_property_overview = async (option) => {
    var response = await fetch(endpoint_link + 'get_property_overview', format_request(option));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const get_agency_report = async (option) => {
    var response = await fetch(endpoint_link + 'get_agency_report', format_request(option));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const get_agency_overview = async (option) => {
    var response = await fetch(endpoint_link + 'get_agency_overview', format_request(option));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
};

export const get_time_agency = async (data) => {
    var response = await fetch(endpoint_link + 'get_agency_over_time', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}

export const get_time_property = async (data) => {
    var response = await fetch(endpoint_link + 'get_property_over_time', format_request(data));
    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        if (json.message == "AUTH FAIL") {
            window.localStorage.clear();
            console.log("authentication broken");
            window.location.href = "/";
        }
        return json;
    }
}
// check forgot password token
export const check_reset_password_token = async (data) => {
    var response = await fetch(access_endpoint_link + "check_reset_password_token", format_request({
        token: data
    }));

    var json = await response.json();
    if (json.status) {
        return true;
    } else {
        alert(json.message);
        return false;
    }
}



export const add_agent = async (data) => {
    var response = await fetch(endpoint_link + "add_agent", format_request(data));

    var json = await response.json();
    if (json.status) {
        return json;
    } else {
        return json;
    }
};